import { GatsbyImage } from 'gatsby-plugin-image';
import { SanityTextButtonImgBgSection } from 'graphql-types';
import React from 'react';
import { findTranslation } from '../../utils/findTranslation';
import { usePageContext } from '../context/pageContext';
import { Blocks } from '../ui/blocks/Blocks';
import * as styles from './textButtonImgBgSection.module.scss';

interface Props {
  section: SanityTextButtonImgBgSection;
}
//TODO link

export const TextButtonImgBgSection: React.FC<Props> = ({ section }) => {
  const { lang, defaultLang } = usePageContext();

  return (
    <div className={styles.wrapper}>
      <div className={styles.image}>
        <GatsbyImage
          image={section?.imgBgSection?.img?.asset?.gatsbyImageData}
          alt={section?.imgBgSection?.alt ?? ''}
        />
        <div className={styles.overlay} />
      </div>
      <div className={styles.imageDesktop}>
        <GatsbyImage
          image={section?.imgBgSection?.img?.asset?.gatsbyImageData}
          alt={section?.imgBgSection?.alt ?? ''}
        />
        <div className={styles.overlay} />
      </div>
      <div className={styles.content}>
        <div className={styles.text}>
          <Blocks blocks={findTranslation(section?._rawTextSection, lang, defaultLang)} />
        </div>
      </div>
    </div>
  );
};
